import axios, { AxiosRequestHeaders } from 'axios';

// Нормализуем baseURL: убираем лишние слэши и хвост "/api", чтобы избежать дублирования при вызове путей вида "/api/..."
const envBase = process.env.REACT_APP_API_URL || 'https://poll.volgatermy.com';
const baseURL = envBase.replace(/\/+$/, '').replace(/\/api$/, '');

export const apiClient = axios.create({ baseURL });

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const headers: AxiosRequestHeaders = (config.headers as AxiosRequestHeaders) || ({} as AxiosRequestHeaders);

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const selectedOrgId = localStorage.getItem('selectedOrgId');
  if (selectedOrgId) {
    headers['X-Organization-Id'] = selectedOrgId;

    const method = (config.method || 'get').toLowerCase();

    if (method === 'get' || method === 'delete') {
      config.params = {
        ...(config.params || {}),
        organizationId: selectedOrgId
      };
    } else if (config.data instanceof FormData) {
      if (config.data.has('organizationId')) {
        config.data.delete('organizationId');
      }
      config.data.append('organizationId', selectedOrgId);
    } else if (config.data && typeof config.data === 'object' && !Array.isArray(config.data)) {
      config.data = {
        ...(config.data as Record<string, unknown>),
        organizationId: selectedOrgId
      };
    } else if (!config.data && (method === 'post' || method === 'put' || method === 'patch')) {
      config.data = { organizationId: selectedOrgId };
    }
  }

  config.headers = headers;
  return config;
});

// Interceptor для обработки ошибок
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Токен недействителен или истек
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('selectedOrgId');
      
      // Перенаправляем на страницу входа, если не находимся на ней
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;


